import { render, staticRenderFns } from "./main2.vue?vue&type=template&id=124fcdee&scoped=true&"
import script from "./main2.vue?vue&type=script&lang=js&"
export * from "./main2.vue?vue&type=script&lang=js&"
import style0 from "./main2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./main2.vue?vue&type=style&index=1&id=124fcdee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124fcdee",
  null
  
)

export default component.exports